import { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Box, CssBaseline, Grid, Toolbar} from '@mui/material';
import './/App.css';
import TopMenu from "./components/TopMenu";
import Footer from "./components/Footer";
import Pools from "./components/Pools";
import PoolX from "./components/PoolX";
import { Helmet } from "react-helmet";
import useAppBarHeight from "./common/appBarHeight";

function App() {

  
  const [darkMode, setDarkMode] = useState(false);    
  const [selected, setSelected] = useState("Home");

  const appBarHeight = useAppBarHeight()-65;

  let mdTheme = createTheme({
    typography: {
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        'Jaldi',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
    },
    palette: {
      mode: darkMode ? 'dark' : 'light',
      primary: {
        light: "#99A6B2",
        main: "#603F83FF",
      },
      secondary: {
        main: "#C7D3D4FF",
      },
    }
  });

  return (

    <Router>      
      <ThemeProvider theme={mdTheme}>
        <CssBaseline />
        <Grid container direction="column">
          <TopMenu selected={selected} setSelected={setSelected}/>         
          <Box sx={{minHeight:appBarHeight + "px"}} />
          <Box                    
            component="main"
            sx={{
              backgroundColor: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[100]
                  : theme.palette.grey[900],
              flexGrow: 1,
              height: '100vh-' + appBarHeight + "px",
              overflow: 'auto',      
              
            }}
          >
            <Helmet>
              <title>Spelvinnare.se - Oddsjämförelse, Liverättning, PoolX, Tips</title>
              <meta name="description" content="Bästa speltipsen och länkar till poolspel på Trav och fotboll. Tipsen skrivs av våra spelvinnare Ola Thimrén, Hans Petersson och Matte Forslund." />
              <meta property="og:url" content="https://www.spelvinnare.se/"></meta>
              <meta property="twitter:url" content="https://www.spelvinnare.se/"></meta>              
            </Helmet>
            <Toolbar />
            <Routes>              
              <Route path="/pools" element={<Pools />} />
              <Route path="/poolx" element={<PoolX />} />              
              <Route path="/" element={<Home />} />              
            </Routes>
            <Footer darkMode={darkMode} setDarkMode={setDarkMode} theme={mdTheme} />
          </Box>
        </Grid>
      </ThemeProvider>      
    </Router>
  );
}

export default App;
